import React from 'react';
import { Form, Formik } from 'formik';
import { SalesPagesHeaderForm } from './SalesPagesHeaderForm';
import { Button } from 'react-covideo-common';
import { SalesPagesValues } from './types';
import { SalesPagesBodyForm } from './SalesPagesBodyForm';
import { IoMdSave } from 'react-icons/io';
import { Gap } from 'lib/components/styles/layout';
import { Heading } from 'lib/components/styles/typography';
import { useAuth } from 'lib/context';
import { SalesPagesCTAForm } from './SalesPagesCTAForm';
import { SalesPagesSocialIconsForm } from './SalesPagesSocialIconsForm';
import { SalesPagesFooterForm } from './SalesPagesFooterForm';
import { useTranslation } from 'react-i18next';

export const SalesPagesForm = ({
  initialValues,
  onSubmitHandler,
}: {
  initialValues: SalesPagesValues;
  onSubmitHandler: (values: SalesPagesValues) => Promise<void>;
}) => {
  const { userData } = useAuth();
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmitHandler}
      enableReinitialize
    >
      {({ submitForm, isSubmitting, dirty }) => {
        return (
          <Form>
            <Gap width='100%' justifyContent='space-between'>
              <Heading>
                {userData.isAutomotiveServiceRole ? t('Service') : t('Sales')}{' '}
                {t('Pages')}
              </Heading>
              <Button
                text={isSubmitting ? t('Saving') : t('Save Changes')}
                type='submit'
                disabled={isSubmitting || !dirty}
                icon={<IoMdSave />}
                onClick={submitForm}
              />
            </Gap>
            <SalesPagesHeaderForm />
            <SalesPagesBodyForm />
            <SalesPagesCTAForm />
            <SalesPagesSocialIconsForm />
            <SalesPagesFooterForm />
          </Form>
        );
      }}
    </Formik>
  );
};
